(function (module) {
  'use strict';
  module.controller('FooterController', ['$rootScope', '$scope', '$q', '$http', 'ngDialog',
    function ($rootScope, $scope, $q, $http, ngDialog) {
      var vm = this;
      $scope.version = "version";
      $scope.build = "build";            

      $scope.showVersionBuild =() => {                
        getBuild().then((response) => {          
          $scope.version = response.data.version;
          $scope.build = response.data.build;
          ngDialog.open({
            template: 'dlg-template-builldversion',
            className: 'ngdialog-theme-plain',
            scope: $scope,
          });
        });        
      }

      const getBuild = () => {
        return $http.get('/build');
      }
    },
  ]);
})(angular.module('obex'));      


// WEBPACK FOOTER //
// ./client/js/controllers/footerController.js